// extracted by mini-css-extract-plugin
export default {"root":"styles_root__TMN8y","titleWrapper":"styles_titleWrapper__0E5XH"};